import React, { useCallback } from 'react';
import { TableBody } from '@material-ui/core';
import TableComponent from '../../DesignSystem/Table';
import { priceRowType, summaryRowType, TableConstants } from '../../../utils/appConstants';
import LoadingRow from '../../DesignSystem/Table/Rows/LoadingRow';
import EmptyRow from '../../DesignSystem/Table/Rows/EmptyRow';
import SummaryRow, { expenseHeadCells, incomeHeadCells } from './row';

interface TableProps {
  priceRow: summaryRowType[];
  loading: boolean;
  type: 'income' | 'expense';
  notApplicable?: boolean;
}

const Table: React.FC<TableProps> = ({
  priceRow, loading, type, notApplicable,
}) => {
  const headCells = (type === 'expense') ? expenseHeadCells : incomeHeadCells;
  let rows;
  if (loading) {
    rows = <LoadingRow colSpan={headCells.length + 1} />;
  } else if (priceRow.length === 0) {
    rows = <EmptyRow text={TableConstants.noRecordsFound} colSpan={headCells.length + 1} />;
  } else {
    const priceRows = priceRow.map((obj: any, index) => {
      return <SummaryRow notApplicable={notApplicable} row={obj} type={type} key={index} />;
    });
    rows = (
      <TableBody>
        {priceRows}
      </TableBody>
    );
  }

  return (
    <TableComponent
      rowCount={priceRow.length}
      headCells={headCells}
      rowSelectionAvailable={false}
      numSelected={0}
      rows={rows}
      totalPages={1}
      page={1}
      onPageChange={() => {}}
    />
  );
};

export default Table;
